export type ProductOrderResponse = {
	requestId: string;
	returnCode: string;
	returnDesc: string;
	referenceId?: string;
};

const model: types.models.InputModel = {
	requestId: 'response.submitProductOrderResponse.result.requestId',
	returnCode: 'response.submitProductOrderResponse.result.returnCode',
	returnDesc: 'response.submitProductOrderResponse.result.returnDesc',
	referenceId: 'response.submitProductOrderResponse.result.orderId',
};

export default model;
